import Chart from 'chart.js/auto';

const PieChart = () => {
    let charts = [];

    const initCharts = () => {
        // Clear previous charts if they exist
        charts.forEach(({ chart }) => chart.destroy());
        charts = [];

        const pieBlocks = document.querySelectorAll('.pie-chart');
        if (!pieBlocks.length) return;

        pieBlocks.forEach(block => {
            // Clear any existing legend content
            const legendEl = block.querySelector('.pie-chart__legend');
            legendEl.innerHTML = '';

            const slices = JSON.parse(block.dataset.slices);
            const labels = slices.map(s => s.label.trim());
            const dataValues = slices.map(s => parseFloat(s.percentage));
            const colours = slices.map(s => s.colour);

            const canvas = block.querySelector('.pie-chart__canvas');
            const ctx = canvas.getContext('2d');

            const chart = new Chart(ctx, {
                type: 'pie',
                data: {
                    labels,
                    datasets: [{
                        data: dataValues,
                        backgroundColor: colours,
                        borderWidth: 1,
                    }]
                },
                options: {
                    plugins: { legend: { display: false } }
                }
            });

            // Build custom legend
            labels.forEach((label, i) => {
                const li = document.createElement('li');
                const marker = document.createElement('span');
                Object.assign(marker.style, {
                    backgroundColor: colours[i]
                });
                li.append(marker, document.createTextNode(label));
                legendEl.appendChild(li);
            });

            charts.push({ chart, block });
        });
    };

    document.addEventListener('DOMContentLoaded', () => {
        initCharts();
    });

    window.addEventListener('resize', () => {
        // Debounce resize to avoid performance issues
        clearTimeout(window.__pieChartResizeTimer);
        window.__pieChartResizeTimer = setTimeout(() => {
            initCharts();
        }, 300);
    });
};

export default PieChart;
